module.exports = __webpack_public_path__ + "static/media/agriculture.d1e7331c.jpg";